/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import LiveProgressBarCommon from '@dtvgo/live-progress-bar';

/* Utils */
import { useCurrentTime } from '../../providers/CurrentTimeProvider';

/* Styles */
import './LiveProgressBar.scss';

function LiveProgressBar({
  className, startDate, endDate, focused,
}) {
  return (
    <LiveProgressBarCommon
      className={`dtv-html5-c-live-progress-bar ${
        focused ? 'dtv-html5-c-live-progress-bar--focused' : ''
      } ${className}`}
      startDate={startDate}
      endDate={endDate}
      currentTime={useCurrentTime()}
    />
  );
}

LiveProgressBar.propTypes = {
  className: PropTypes.string,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  focused: PropTypes.bool,
};

LiveProgressBar.defaultProps = {
  className: '',
  startDate: undefined,
  endDate: undefined,
  focused: false,
};

export default memo(LiveProgressBar);
